var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toolbarTopWrapper" }, [
    _c(
      "div",
      {
        class: [
          "topToolbar",
          {
            fixed: _vm.fixedPosition,
            inverse: _vm.inverseColors,
            expanded: !_vm.collapsed,
          },
        ],
      },
      [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("div", { staticClass: "containerContent" }, [
              _c("div", { staticClass: "leftAligned" }, [
                _vm.hasBackButton
                  ? _c(
                      "div",
                      {
                        staticClass: "backButton",
                        attrs: { id: "tourHandleBackButton" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("clickBackButton")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "icon" },
                          [
                            _vm._t("backButtonIcon", function () {
                              return [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tkeyboard_arrow_left\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "text" },
                          [
                            _vm._t("backButtonText", function () {
                              return [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t("buttonBack")) +
                                    "\n\t\t\t\t\t\t\t"
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "centerAligned" }, [
                _c("div", { staticClass: "title" }, [_vm._t("title")], 2),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "rightAligned" }, [
                _vm.hasActionButton
                  ? _c(
                      "div",
                      {
                        staticClass: "actionButton",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("clickActionButton")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "icon" },
                          [_vm._t("actionButtonIcon")],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "text" },
                          [_vm._t("actionButtonText")],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasUndoRedoButton
                  ? _c(
                      "button",
                      {
                        staticClass: "undoButton",
                        attrs: {
                          id: "tourHandleUndoButton",
                          disabled: !_vm.hasUndo,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("clickUndoButton")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("\n\t\t\t\t\t\t\tundo\n\t\t\t\t\t\t"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasUndoRedoButton
                  ? _c(
                      "button",
                      {
                        staticClass: "redoButton",
                        attrs: { disabled: !_vm.hasRedo },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("clickRedoButton")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("\n\t\t\t\t\t\t\tredo\n\t\t\t\t\t\t"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "divider" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.menuItems.length,
                        expression: "menuItems.length",
                      },
                    ],
                    ref: "moreButton",
                    staticClass: "moreButton",
                    attrs: { id: "tourHandleMenuButton" },
                    on: { click: _vm.clickMoreButton },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s("more_horiz") +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.hasProceedButton
                  ? _c(
                      "div",
                      {
                        staticClass: "actionbutton altColor proceedButton",
                        attrs: { id: "tourHandleProceedButtonDesktop" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("clickProceedButton")
                          },
                        },
                      },
                      [_vm._t("proceedButtonText")],
                      2
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "SelectMenuView",
              {
                attrs: {
                  "menu-items": _vm.menuItems,
                  open: !_vm.collapsed,
                  position: JSON.parse(JSON.stringify(_vm.menuPosition)),
                  placement: "left-start",
                },
                on: {
                  closeMenu: function ($event) {
                    _vm.collapsed = true
                  },
                },
              },
              [_vm._t("selectMenuHeader")],
              2
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }